import { ApplicationQuestionReviewItem } from '../../../../../components/ApplicationQuestionReviewItem';
import { DropDownBox } from '@apply/components';
import { ExitTypeOptions } from '@apply/constants';
import { useExitType } from '../../../../../../queries/PropertyFields';
export interface ExitTypeFieldProps {
    propertyGuid: string;
    width?: string;
    required?: boolean;
    isReview?: boolean;
}

export const ExitTypeField: React.FC<ExitTypeFieldProps> = ({ propertyGuid, required = false, width, isReview = false }) => {
    const label = (
        <>
            Select the most <strong>accurate</strong> exit for this property
        </>
    );
    const [exitType, set_exitType] = useExitType(propertyGuid);

    const exitTypeList = ExitTypeOptions.slice()
        .sort((a, b) => a.sortOrder - b.sortOrder)
        .map((o) => ({
            display: o.name,
            value: o.id,
        }));

    const findExitTypeByValue = (value: number | undefined) => {
        return exitTypeList.find((bt) => bt.value == value)?.display;
    };

    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={findExitTypeByValue(exitType)}
                />
            ) : (
                <DropDownBox
                    id={'exitTypeDropDown'}
                    value={exitType}
                    onChange={(value) => set_exitType(value)}
                    required={required}
                    dataSource={exitTypeList}
                    displayExpr='display'
                    valueExpr='value'
                    width={width}
                    label={label}
                />
            )}
        </>
    );
};
